import React from 'react';
import { useLocation, useSearchParams, Navigate } from 'react-router-dom';
import { useUser } from '../../auth/AuthPage/UserContext';
import LoginGate from '../../common/LoginGate/LoginGate';
import OneSearch from './OneSearch';
import './Search.css';

/**
 * Search Page = ONE SEARCH.
 *
 * One box, one grid of cards, location + card filters in the rail,
 * people-finding in Tools. The old advanced card browser is gone -
 * the rail and the card window cover it.
 *
 * Legacy URLs keep working:
 *   ?tab=users        -> the Middlemen tool page
 *   ?view=recommended -> the Find Traders tool page
 */
function Search() {
    const { user } = useUser();
    const [searchParams] = useSearchParams();
    // The homepage hero search navigates here with a card name to run immediately
    const heroCardName = useLocation().state?.cardName || '';

    // Legacy URLs from before the tools became pages
    if (searchParams.get('view') === 'recommended') return <Navigate to="/traders" replace />;
    if (searchParams.get('tab') === 'users') return <Navigate to="/middlemen" replace />;

    if (!user) {
        return <LoginGate title="Search" message="Log in to search cards and traders." />;
    }

    return (
        <div className="search-container">
            <header className="page-section-head">
                <h1>Search</h1>
            </header>

            <div className="search-content">
                <OneSearch initialQuery={heroCardName} />
            </div>
        </div>
    );
}

export default Search;
